/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ClientResource } from './';
import {
    ClientResourceFromJSON,
    ClientResourceFromJSONTyped,
    ClientResourceToJSON,
} from './';
import type { FreelancerResource } from './';
import {
    FreelancerResourceFromJSON,
    FreelancerResourceFromJSONTyped,
    FreelancerResourceToJSON,
} from './';
import type { ProjectTypeResource } from './';
import {
    ProjectTypeResourceFromJSON,
    ProjectTypeResourceFromJSONTyped,
    ProjectTypeResourceToJSON,
} from './';
import type { ReferredProjectDeliverableResource } from './';
import {
    ReferredProjectDeliverableResourceFromJSON,
    ReferredProjectDeliverableResourceFromJSONTyped,
    ReferredProjectDeliverableResourceToJSON,
} from './';
import type { ReferredProjectStatus } from './';
import {
    ReferredProjectStatusFromJSON,
    ReferredProjectStatusFromJSONTyped,
    ReferredProjectStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface ReferredProjectResource
 */
export interface ReferredProjectResource {
    /**
     * 
     * @type {string}
     * @memberof ReferredProjectResource
     */
    id: string;
    /**
     * Project's id
     * @type {string}
     * @memberof ReferredProjectResource
     */
    projectId: string;
    /**
     * Project's name
     * @type {string}
     * @memberof ReferredProjectResource
     */
    projectTitle: string;
    /**
     * 
     * @type {ProjectTypeResource}
     * @memberof ReferredProjectResource
     */
    projectType: ProjectTypeResource;
    /**
     * 
     * @type {ReferredProjectStatus}
     * @memberof ReferredProjectResource
     */
    status: ReferredProjectStatus;
    /**
     * Project's deliverables
     * @type {Array<ReferredProjectDeliverableResource>}
     * @memberof ReferredProjectResource
     */
    deliverables: Array<ReferredProjectDeliverableResource>;
    /**
     * it's the first project on this referral
     * @type {string}
     * @memberof ReferredProjectResource
     */
    initialReferredProjectId?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferredProjectResource
     */
    currencyCode: string;
    /**
     * ex= reward, referrer can be updated only before a project is done and without invoice generated
     * @type {boolean}
     * @memberof ReferredProjectResource
     */
    canUpdateInternalReferralData?: boolean;
    /**
     * 
     * @type {FreelancerResource}
     * @memberof ReferredProjectResource
     */
    freelancer: FreelancerResource;
    /**
     * 
     * @type {ClientResource}
     * @memberof ReferredProjectResource
     */
    client: ClientResource;
}

/**
 * Check if a given object implements the ReferredProjectResource interface.
 */
export function instanceOfReferredProjectResource(value: object): value is ReferredProjectResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('projectId' in value) || value['projectId'] === undefined) return false;
    if (!('projectTitle' in value) || value['projectTitle'] === undefined) return false;
    if (!('projectType' in value) || value['projectType'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('deliverables' in value) || value['deliverables'] === undefined) return false;
    if (!('currencyCode' in value) || value['currencyCode'] === undefined) return false;
    if (!('freelancer' in value) || value['freelancer'] === undefined) return false;
    if (!('client' in value) || value['client'] === undefined) return false;
    return true;
}

export function ReferredProjectResourceFromJSON(json: any): ReferredProjectResource {
    return ReferredProjectResourceFromJSONTyped(json, false);
}

export function ReferredProjectResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferredProjectResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'projectId': json['projectId'],
        'projectTitle': json['projectTitle'],
        'projectType': ProjectTypeResourceFromJSON(json['projectType']),
        'status': ReferredProjectStatusFromJSON(json['status']),
        'deliverables': ((json['deliverables'] as Array<any>).map(ReferredProjectDeliverableResourceFromJSON)),
        'initialReferredProjectId': json['initialReferredProjectId'] == null ? undefined : json['initialReferredProjectId'],
        'currencyCode': json['currencyCode'],
        'canUpdateInternalReferralData': json['canUpdateInternalReferralData'] == null ? undefined : json['canUpdateInternalReferralData'],
        'freelancer': FreelancerResourceFromJSON(json['freelancer']),
        'client': ClientResourceFromJSON(json['client']),
    };
}

export function ReferredProjectResourceToJSON(value?: ReferredProjectResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'projectId': value['projectId'],
        'projectTitle': value['projectTitle'],
        'projectType': ProjectTypeResourceToJSON(value['projectType']),
        'status': ReferredProjectStatusToJSON(value['status']),
        'deliverables': ((value['deliverables'] as Array<any>).map((v) => ReferredProjectDeliverableResourceToJSON(v))),
        'initialReferredProjectId': value['initialReferredProjectId'],
        'currencyCode': value['currencyCode'],
        'canUpdateInternalReferralData': value['canUpdateInternalReferralData'],
        'freelancer': FreelancerResourceToJSON(value['freelancer']),
        'client': ClientResourceToJSON(value['client']),
    };
}

